/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./aparcare.component";
var styles_AparcareComponent = [];
var RenderType_AparcareComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_AparcareComponent, data: {} });
export { RenderType_AparcareComponent as RenderType_AparcareComponent };
export function View_AparcareComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, [" aparcare works!\n"]))], null, null); }
export function View_AparcareComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-aparcare", [], null, null, null, View_AparcareComponent_0, RenderType_AparcareComponent)), i0.ɵdid(1, 114688, null, 0, i1.AparcareComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AparcareComponentNgFactory = i0.ɵccf("app-aparcare", i1.AparcareComponent, View_AparcareComponent_Host_0, {}, {}, []);
export { AparcareComponentNgFactory as AparcareComponentNgFactory };
